import{m as e}from"./chunk-HBP5N4FR.js";e();var t=()=>Boolean(window==null?void 0:window.elrondWallet);export{t as a};
//# sourceMappingURL=chunk-53GKFOIV.js.map
